import Controls from "../components/Controls";
import Progress from "../components/Progress";
import RoomHeader from "../components/RoomHeader";
import audioTablet from "../assets/images/icons/audio-tablet.svg";
import { useTranslation } from "../components/Localization";
import { useTourMode } from "../components/TourMode";

export default function AudioTaskPage() {
  const { room, t } = useTranslation();
  const { interactive } = useTourMode();
  const instruction = room("dining")?.tasks.audio;
  return (
    <main className="screen activity">
      <RoomHeader roomId="dining" />
      <p className="instruction">{instruction}</p>
      <img
        className="audio-tablet"
        src={audioTablet}
        alt={t("audio.play")}
      />
      <Progress step={0} total={4} icon="top-right" showDots={interactive} />
      <Controls backTo="/talalo" nextTo="/talalo/parositas" />
    </main>
  );
}
